import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AppState} from '../../../app.store';
import {Store} from '@ngrx/store';
import {SaveUserToEdit, UpdateUserToEdit} from '../../state/user.actions';
import {take} from 'rxjs/operators';
import {Gallery, GalleryRef} from '@ngx-gallery/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UserToEdit} from '../../state/users.reducer';
import {UserService} from '../../services';
import {PortfolioBaseComponent} from '../../containers/portfolio/portfolio-base/portfolio-base.component';

@Component({
  selector: 'app-user-portfolio-edit',
  templateUrl: './portfolio-edit.component.html',
  styleUrls: ['./portfolio-edit.component.scss']
})
export class PortfolioEditComponent implements OnInit, OnDestroy {
  state: any;
  galleryRef: GalleryRef;
  showDescriptionEdit = false;
  private _user: UserToEdit;
  @Input()
  set user(user: UserToEdit) {
    console.log('setting user ', user);
    if ( user === undefined) {
      return;
    }
    this._user = user;
    if (this.galleryRef) {
      this.galleryRef.reset();
    } else {
      this.galleryRef = this.gallery.ref('gallery');
    }

    if (this._user.newImages) {
      this._user.newImages.filter( img => img.src.toString().length > 0 ).map((img: {src: string|ArrayBuffer, file: File}) => {
        console.log('adding img', img);
        this.galleryRef.addImage({
          src: img.src,
          thumb: img.src
        });
      });
    }

    if (this._user.youtubes) {
      this._user.youtubes.filter(str => str.length > 0).map((src) => {
        console.log('youtube is ', src);
        this.galleryRef.addYoutube({src});
      });
    }
  }

  get user() {
    return this._user;
  }


  private showYoutubeInput = false;
  newYoutube: string;

  public loader$;
  constructor(private route: ActivatedRoute,
              private gallery: Gallery,
              private modalService: NgbModal,
              private userService: UserService,
              private router: Router,
              private store: Store<AppState>) { }

  ngOnInit() {
    this.loader$ = this.store.select(state => state.loading.active);

  }

  ngOnDestroy(): void {
  }
  handleUploadImageClick(type: string) {
    const input = document.createElement('input');
    input.type = 'file';
    if ( type === 'gallery') {
      input.onchange = this.uploadGalleryImage.bind(this);
    } else {
      input.onchange = this.uploadBannerImage.bind(this);
    }
    input.click();
  }

  uploadGalleryImage($event) {
    $event.preventDefault();
    const reader = new FileReader();
    const file = $event.target.files[0];
    reader.onload = () => {
      const newUser  = Object.assign({}, this.user, {newImages: [...this.user.newImages, {src: reader.result, file}]});
      this.store.dispatch(new UpdateUserToEdit(newUser));
      this.galleryRef.state.pipe(
        take(1)).subscribe( states => {
        this.galleryRef.set(states.items.length - 1 );
      });
    };
    reader.readAsDataURL(file);

  }

  uploadBannerImage($event) {
    console.log('this is ', this);
    $event.preventDefault();
    const reader = new FileReader();
    const file = $event.target.files[0];
    reader.onload = () => {
      this.user.newBannerImageFile = file;
      this.user.newBannerImageUrl = reader.result;
    };
    reader.readAsDataURL(file);

  }

  toggleYoutube() {
    if ( this.showYoutubeInput) {

      const youtubeId = (document.getElementById('newYoutube') as HTMLInputElement).value;
      const id = this.getIdFromYoutubeUrl(youtubeId);
      if (id !== undefined && youtubeId.trim().length > 0) {
        const newUser = Object.assign({}, this.user, {youtubes: [...this.user.youtubes, id]});
        this.store.dispatch(new UpdateUserToEdit(newUser));
      }
    }
    this.showYoutubeInput = !this.showYoutubeInput;

  }

  private getIdFromYoutubeUrl(str: string) {
      const url = str.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
      return (url[2] !== undefined) ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
    }

  descriptionEdit() {
    if (this.showDescriptionEdit) {
      const newUser = Object.assign({}, this.user);
      this.store.dispatch(new UpdateUserToEdit(newUser));
    }
    this.showDescriptionEdit = !this.showDescriptionEdit;
  }

  removeImage( item: {type: string,  index: number}) {
    console.log('remove index from gallery ', item.index, item.type, this.user.newImages);
    let newUser: UserToEdit;
    if ( item.type === 'image') {
      const newImages = [...this.user.newImages];
      newImages.splice(item.index, 1 );
      console.log('after slice  ', newImages);
      newUser = Object.assign({}, this.user, {
        newImages
      });
    } else if ( item.type === 'youtube') {
      const youtubes = [...this.user.youtubes];
      youtubes.splice(item.index, 1 );
      newUser = Object.assign({}, this.user, {
        youtubes
      });
    }
    this.store.dispatch(new UpdateUserToEdit(newUser));
  }

  save() {
    // console.log('%O', this.user);
    this.store.dispatch(new SaveUserToEdit(this.user));
  }

  showPreview(content) {
    this.userService.previewUser = this._user;
    console.log('preview setting user', this._user);
    const modalRef = this.modalService.open(content, { size: 'lg', windowClass: 'full' });
    modalRef.componentInstance.user = this._user;

  }
}
